import { Controller, useFormContext } from 'react-hook-form';
import { TmdxTextarea } from '@ds';
import { DonorFormRow } from './DonorFormRow';
import { DonorProfileFormValues } from '../types';

/** Shared across organs — keep outside the per-organ sections. */
type ReasonForUnallocatedRowProps = {
  showRequired?: boolean;
};

export const ReasonForUnallocatedRow = ({ showRequired = true }: ReasonForUnallocatedRowProps) => {
  const { control } = useFormContext<DonorProfileFormValues>();

  return (
    <DonorFormRow title="Reason for Unallocated" isRequired={showRequired} multiRow>
      <Controller
        name="reasonForUnallocated"
        control={control}
        render={({ field, fieldState: { invalid, error } }) => (
          <TmdxTextarea
            aria-label="Reason for unallocated"
            maxLength={128}
            isInvalid={invalid}
            errorMessage={error?.message}
            {...field}
            value={field.value ?? ''}
          />
        )}
      />
    </DonorFormRow>
  );
};
